import React, { Suspense, useEffect, useRef, useState } from "react";
import { useProgress } from "@react-three/drei";


import Bocca from './assets/bocca.svg'
// import Cup from './assets/cup.svg'
import Cup from './assets/cup.js'
import Logo from './assets/banzai_logo_splash.svg'

import CtaPrimary from "../../UI/Cta/Primary/CtaPrimary";
import CtaSecondary from "../../UI/Cta/Secondary/CtaSecondary";

import "./loader.scss"



function LoaderPage({ onStart, toggleSound, setMount}){
    let { loaded } = useProgress()
    const load = window.location.pathname === '/' || window.location.pathname === '/cookie-policy/' || window.location.pathname === '/privacy-policy/' || window.location.pathname === '/404/' ? 24 : 28 // 28 // index of asset to load
    

    const containerRef = useRef()
    const boccaRef = useRef()
    const cupRef = useRef()
    const loadingRef = useRef()
    const logoRef = useRef()

    const [actualColor, setActualColor] = useState()
    const [cupAnimate, setCupAnimate] = useState(false);
    const [boccaAnimate, setBoccaAnimate] = useState(false);
    const [showLoading, setShowLoading] = useState(false); // Stato per gestire la visibilità del caricamento

    const colors = ['#DE241D', '#EFB122', '#44A043', '#E25406', '#A45A96']

    function introAnimation(){

        const cupTimer = setTimeout(() => {
            setCupAnimate(true);

            // Avvia l'animazione della bocca
            setBoccaAnimate(true);
        }, 1000);

        // Pulizia del timer per evitare memory leaks
        return () => clearTimeout(cupTimer);

    }

    function enterExperience(sound){

        
        logoRef.current.classList.remove('banzai_splash_screen__login--animate');
        
        
        containerRef.current.classList.add('banzai_splash_screen--transparent');
        
        setTimeout(() => {
            setMount()
            setShowLoading(true)
        }, 500);

        setTimeout(() => {
            if(sound){
                onStart()
            }
            else{
                toggleSound()
                onStart()
            }
        }, 2000);
        
        
    }
    
    useEffect(() => {
        const randomColor = colors[Math.floor(Math.random() * colors.length)]
        setActualColor(randomColor)
        introAnimation()
    }, []);
    
    useEffect(() => {
        // Controlla se loaded è uguale a load e nasconde l'elemento di caricamento se necessario
        if (loaded === load) {
            cupRef.current.classList.add('cup--hide');
            boccaRef.current.classList.add('bocca--hide');
            setTimeout(() => {
                showLoading && loadingRef.current.classList.add('banzai_splash_screen__loading--animate');
            }, 500);
            // add opacity 0 to loading
            setTimeout(() => {  
                setActualColor(null)
                setCupAnimate(false)
                setBoccaAnimate(false)
                setShowLoading(prev => !prev);
                containerRef.current.classList.add('banzai_splash_screen--hide');
            },2000)
        }
    }, [load, loaded]);
    

    return(
    <Suspense fallback={null} >
        <div ref={containerRef} className={`banzai_splash_screen`} >

            <img ref={boccaRef} src={Bocca} alt="Bocca" className={`bocca ${boccaAnimate ? 'bocca--animate' : ''}`} />

            <div ref={cupRef} className={`cup ${cupAnimate ? 'cup--animate' : ''}`}>
                <Cup color={actualColor} className="cup__img" />
                <div style={{backgroundColor: actualColor, minHeight: '100vh', height:'100%', width:'100%', transform: 'translateY(-1%)', }}></div>
            </div>
            
            {showLoading && (
                <span ref={loadingRef} className={`banzai_splash_screen__loading`}>
                    {parseInt((100 / load) * loaded) + "%"}
                </span>
            )}

            <div ref={logoRef} className={`banzai_splash_screen__login ${cupAnimate && boccaAnimate && !showLoading && 'banzai_splash_screen__login--animate'}`} >
                <img src={Logo} alt="Banzai Logo" />
                <div style={{display:'flex', flexDirection:'column', alignItems:'center', justifyContent: 'center', gap: '1rem'}}>
                <CtaPrimary onClick={enterExperience} text="Start"/>
                <CtaSecondary onClick={() => enterExperience(false)} text="Entra senza audio"/>
                </div>       
            </div>

        </div>
    </Suspense>
    )
}

export default LoaderPage